<template>
  <v-list two-line v-if="obligations && obligations.length > 0">
    <template v-for="(obligation, index) in obligations">
      <v-list-item :key="obligation._id">
        <v-list-item-action v-if="!isInvalidObligation(obligation)">
          <v-icon color="success">check_circle</v-icon>
        </v-list-item-action>
        <v-list-item-action v-else>
          <v-icon color="error">error</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ obligation.name }}</v-list-item-title>
          <v-list-item-subtitle
            class="error--text"
            v-if="isInvalidObligation(obligation)"
            >{{ getFirstInvalidMessage(obligation) }}</v-list-item-subtitle
          >
        </v-list-item-content>
        <v-list-item-action
          v-if="
            obligation.dueDateType == 'date_limit' &&
              $vuetify.breakpoint.smAndUp"
        >
          <v-list-item-action-text class="text-xs-center">
            <div>{{ resx.labels.dueDateAb }}</div>
            <div>{{ obligation.dueDate | date }}</div>
          </v-list-item-action-text>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn
            icon
            text
            color="primary"
            :disabled="!obligation.comments"
            @click="
              $emit('viewComment', {
                title: obligation.name,
                value: obligation.comments
              })
            "
          >
            <v-icon>comment</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider
        v-if="index != obligations.length - 1"
        :key="'_' + obligation._id"
      ></v-divider>
    </template>
  </v-list>
  <v-alert color="primary" icon="info" v-else :value="true">
    {{ resx.messages.noDataAvailable }}
  </v-alert>
</template>

<script>
"use strict";

import contractorCompanyService from "@/services/ContractorCompanyService";

export default {
  name: "contractorObligationsDetails",
  methods: {
    isInvalidObligation: contractorCompanyService.isInvalidObligation,
    getFirstInvalidMessage: contractorCompanyService.getFirstInvalidMessage
  },
  props: {
    obligations: { type: Array }
  }
};
</script>

<style lang="scss">
@media (max-width: 599px) {
  .v-list .v-list-item {
    height: auto !important;
    min-height: 48px;
    align-items: flex-start;
    padding-top: 8px;
    padding-bottom: 8px;
    overflow: visible !important;
  }

  .v-list .v-list-item__content {
    overflow: visible !important;
  }

  .v-list .v-list-item__action {
    align-self: flex-start;
    margin-top: 4px;
    min-width: 36px !important;
  }

  .v-list .v-list-item__title,
  .v-list .v-list-item__subtitle {
    white-space: normal !important;
    word-break: break-word;
    font-size: 0.85rem;
  }
}
</style>
